import React, { useEffect, useState } from 'react';
import {
  MDBTypography,
  MDBSpinner,
  MDBCard,
  MDBCardBody,
  MDBCardTitle,
  MDBCardText,
  MDBRow,
  MDBCol,
  MDBIcon,
  MDBBtn,
  MDBInput,
  MDBModal,
  MDBModalDialog,
  MDBModalContent,
  MDBModalHeader,
  MDBModalTitle,
  MDBModalBody,
  MDBModalFooter
} from 'mdb-react-ui-kit';

import poppyImage from '../assets/images/poppy_img.jpg';
import sampImage from '../assets/images/samp_img.jpg';
import dandImage from '../assets/images/dandelion_img.jpg';
import rosesImage from '../assets/images/roses_img.jpg';
import tulipsImage from '../assets/images/tulips_img.jpg';
import defaultImage from '../assets/images/default_img.jpg';

function ProductsTab({ user }) {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [sortOption, setSortOption] = useState('product_no');

  const [selectedProduct, setSelectedProduct] = useState(null);
  const [showModal, setShowModal] = useState(false);
  const [formError, setFormError] = useState('');

  const [createModal, setCreateModal] = useState(false);
  const toggleCreateModal = () => setCreateModal(!createModal);

  const [inventory, setInventory] = useState([]);

  const [editFields, setEditFields] = useState({
    product_name: '',
    type: '',
    price: '',
    status: ''
  });

  const [formProductData, setFormProductData] = useState({
    product_name: '',
    product_no: '',
    type: 'Fixed',
    price: '',
    status: 'Active',
    selectedInventoryItem: '',
    quantity: 0
  });

  const getProductImage = (productNo) => {
    const images = {
      F001: poppyImage,
      F002: rosesImage,
      F003: tulipsImage,
      F004: dandImage,
      F005: sampImage
    };
    return images[productNo] || defaultImage;
  };

  const fetchProducts = async () => {
    setLoading(true);
    try {
      const response = await fetch('https://krizkhen-floral-design.onrender.com/api/products/get-all-products');
      if (!response.ok) throw new Error(`HTTP error! Status: ${response.status}`);
      const data = await response.json();
      setProducts(data);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const fetchInventory = async () => {
    try {
      const res = await fetch('https://krizkhen-floral-design.onrender.com/api/inventory/get-all-inventory');
    if (!res.ok) throw new Error('Failed to fetch inventory');
      const data = await res.json();
      setInventory(data);
    } catch (err) {
      console.error(err);
    }
  };


  useEffect(() => {
    fetchProducts();
    fetchInventory();
  }, []);



  const openEditModal = (product) => {
    setSelectedProduct(product);
    setEditFields({
      product_name: product.product_name,
      type: product.type,
      price: product.price,
      status: product.status
    });
    setShowModal(true);
  };

  const handleSaveProduct = async () => {
    try {
      const response = await fetch(
        `https://krizkhen-floral-design.onrender.com/api/products/update-product/${selectedProduct.product_no}`,
        {
          method: 'PATCH',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify(editFields)
        }
      );

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Failed to update product');

      setShowModal(false);
      fetchProducts();
    } catch (err) {
      alert(err.message);
    }
  };

  const handleDeleteProduct = async () => {
    if (!selectedProduct) return;

    const confirmDelete = window.confirm(
      `Are you sure you want to delete ${selectedProduct.product_name}?`
    );

    if (!confirmDelete) return;

    try {
      const response = await fetch(
        `https://krizkhen-floral-design.onrender.com/api/products/delete-product/${selectedProduct.product_no}`,
        {
          method: 'DELETE',
        }
      );

      const data = await response.json();
      if (!response.ok) throw new Error(data.error || 'Failed to delete product');

      setShowModal(false);
      fetchProducts(); 
    } catch (err) {
      alert(err.message);
    }
  };













  const handleCreateProduct = async () => {
    const { product_name, product_no, price, selectedInventoryItem, quantity } = formProductData;

    if (!product_name || !product_no || !price, !selectedInventoryItem || !quantity) {
      alert("Please complete all required fields.");
      return;
    }

    try {

      const createProductRes = await fetch('https://krizkhen-floral-design.onrender.com/api/products/create-product', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          product_no: product_no,
          product_name: product_name,
          price: price,
          type: 'Fixed',
          status: 'Active',
        }),
      });

      const createProductData = await createProductRes.json();
      if (!createProductRes.ok) throw new Error(createProductData.error || 'Failed to create product');




      const createBomRes = await fetch('https://krizkhen-floral-design.onrender.com/api/bom/create-bom', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
            product_no: product_no, 
            material_no: selectedInventoryItem,
            quantity: quantity,
        }),
      });

      const createBomData = await createBomRes.json();
      if (!createBomRes.ok) throw new Error(createBomData.error || 'Failed to create bom');


      setFormProductData({
        product_no: "",
        product_name: "",
        price: "",
        selectedInventoryItem: "",
        quantity: "",
      });


      setCreateModal(false);
      fetchProducts();

    } catch (err) {
      alert("Error: " + err.message);
    }
  };











  const sortedProducts = [...products].sort((a, b) => {
    if (sortOption === 'price') return a.price - b.price;
    if (sortOption === 'product_name') return a.product_name.localeCompare(b.product_name);
    if (sortOption === 'status') return a.status.localeCompare(b.status);
    if (sortOption === 'type') return a.type.localeCompare(b.type);
    return a.product_no.localeCompare(b.product_no);
  });

  if (loading) {
    return (
      <div className="d-flex justify-content-center mt-5">
        <MDBSpinner role="status">
          <span className="visually-hidden">Loading...</span>
        </MDBSpinner>
      </div>
    );
  }

  if (error) {
    return (
      <MDBTypography tag="p" className="text-danger text-center mt-4">
        Error: {error}
      </MDBTypography>
    );
  }

  return (
    <div className="mt-4 w-100">

      {/* Header and Sorting */}
      <MDBRow className="align-items-center mb-4">
        <MDBCol>
          <MDBTypography tag="h1" className="custom-font" style={{ color: '#A78D79' }}>
            Products
          </MDBTypography>
        </MDBCol>


        <MDBCol md="auto" className="ms-auto">
          <div className="d-flex align-items-center justify-content-end flex-wrap gap-3 w-100">
            <div className="d-flex align-items-center gap-2 flex-nowrap">
              <MDBTypography className="mb-0 me-2" style={{ minWidth: '65px' }}>
                Sort by:
              </MDBTypography>
              <select
                className="form-select"
                value={sortOption}
                onChange={(e) => setSortOption(e.target.value)}
                style={{ minWidth: '180px' }}
              >
                <option value="product_no">Product No#</option>
                <option value="product_name">Product Name</option>
                <option value="type">Type</option>
                <option value="price">Price</option>
                <option value="status">Status</option>
              </select>
            </div>

            <MDBBtn style={{ backgroundColor: '#A78D79' }} onClick={toggleCreateModal}>
              ADD PRODUCT
            </MDBBtn>
          </div>
        </MDBCol>


      </MDBRow>

      {/* Product Cards */}
      {sortedProducts.length === 0 ? (
        <MDBTypography tag="p" className="text-center mt-3">
          No products found.
        </MDBTypography>
      ) : (
        <MDBRow className="g-3 mb-3">
          {sortedProducts.map((product) => (
            <MDBCol key={product._id} size="12">
              <MDBCard
                className="border-0 shadow-sm"
                style={{
                  borderRadius: '15px',
                  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
                  cursor: 'pointer',
                  backgroundColor: 'rgba(245, 245, 245, 1)'
                }}
                onClick={() => openEditModal(product)}
                onMouseEnter={(e) => {
                  e.currentTarget.style.transform = 'translateY(-3px)';
                  e.currentTarget.style.boxShadow = '0 8px 20px rgba(0, 0, 0, 0.15)';
                }}
                onMouseLeave={(e) => {
                  e.currentTarget.style.transform = 'translateY(0)';
                  e.currentTarget.style.boxShadow = '0 4px 12px rgba(0, 0, 0, 0.08)';
                }}
              >
                <MDBCardBody className="d-flex align-items-center flex-wrap gap-3">

                  {/* LEFT: Image */}
                  <div
                    style={{
                      height: '120px',
                      borderRadius: '12px',
                      overflow: 'hidden',
                      backgroundColor: '#f8f8f8'
                    }}
                  >
                    <img
                      src={getProductImage(product.product_no)}
                      alt={product.product_name}
                      style={{
                        width: '120px',
                        height: '100%',
                        objectFit: 'cover'
                      }}
                    />
                  </div>

                  {/* MIDDLE: Info */}
                  <div className="flex-grow-1 ms-2">
                    <MDBCardTitle className="fw-bold mb-1">
                      {product.product_name}
                    </MDBCardTitle>
                    <MDBCardText className="mb-2 d-flex align-items-center gap-2">
                      <span className='me-1'>
                        <strong>Type:</strong> {product.type}
                      </span>
                      <span className={`badge ${product.status === 'Active' ? 'bg-success' : 'bg-secondary'}`}>
                        {product.status}
                      </span>
                    </MDBCardText>
                    <MDBCardText className="text-muted mt-2">
                      <MDBIcon fas icon="tag" className="me-2 text-secondary" />
                      {product.product_no}
                    </MDBCardText>
                  </div>

                  {/* RIGHT: Price */}
                  <div className="text-end ms-auto">
                    <MDBTypography tag="h5" className={`fw-bold mb-2`}>
                      <MDBIcon fas icon="peso-sign" className="me-1" />
                      {product.price?.toFixed(2)}
                    </MDBTypography>
                  </div>

                </MDBCardBody>
              </MDBCard>
            </MDBCol>
          ))}
        </MDBRow>
      )}





      <MDBModal open={showModal} tabIndex="-1">
        <MDBModalDialog centered>
          <MDBModalContent>
            <MDBModalHeader>
              <MDBModalTitle>Edit Product</MDBModalTitle>
              <MDBBtn className="btn-close" color="none"  onClick={() => setShowModal(false)}></MDBBtn>
            </MDBModalHeader>

            <MDBModalBody>

              <MDBInput
                label="Product Name"
                className="mb-3"
                value={editFields.product_name}
                onChange={(e) => setEditFields({ ...editFields, product_name: e.target.value })}
              />

              <MDBInput
                label="Type"
                className="mb-3"
                value={editFields.type}
                onChange={(e) => setEditFields({ ...editFields, type: e.target.value })}
              />

              <MDBInput
                label="Price"
                type="number"
                className="mb-3"
                value={editFields.price}
                onChange={(e) => setEditFields({ ...editFields, price: Number(e.target.value) })}
              />

              <select
                className="form-select"
                value={editFields.status}
                onChange={(e) => setEditFields({ ...editFields, status: e.target.value })}
              >
                <option value="Active">Active</option>
                <option value="Inactive">Inactive</option>
              </select>


              {formError && <p className="text-danger small mb-0">{formError}</p>}
            </MDBModalBody>

            <MDBModalFooter className="d-flex justify-content-between">

              <div>
                <MDBBtn color="danger" className="me-2" onClick={() => setShowModal(false)}> Cancel </MDBBtn>
                <MDBBtn color="success" onClick={handleSaveProduct}> Save Changes </MDBBtn>
              </div>
            </MDBModalFooter>

          </MDBModalContent>
        </MDBModalDialog>
      </MDBModal>




      
      
            {/* Create Custom Order Modal */}
            <MDBModal open={createModal} tabIndex="-1">
              <MDBModalDialog centered>
                <MDBModalContent>
                  <MDBModalHeader>
                    <MDBModalTitle>Add Product</MDBModalTitle>
                    <MDBBtn className="btn-close" color="none" onClick={toggleCreateModal}></MDBBtn>
                  </MDBModalHeader>
      
                  <MDBModalBody>
                    <MDBTypography tag="label" className="fw-bold mb-2">
                      Product Info
                    </MDBTypography>

                    <MDBInput
                      className="mb-3"
                      label="Product Number"
                      value={formProductData.product_no}
                      onChange={(e) =>
                        setFormProductData({ ...formProductData, product_no: e.target.value })
                      }
                    />

                    <MDBInput
                      className="mb-3"
                      label="Product Name"
                      value={formProductData.product_name}
                      onChange={(e) =>
                        setFormProductData({ ...formProductData, product_name: e.target.value })
                      }
                    />

                    <MDBInput
                        label="Price"
                        type="number"
                        value={formProductData.price}
                        onChange={(e) =>
                          setFormProductData({ ...formProductData, price: parseInt(e.target.value) })
                        }
                    />
      

                    <MDBTypography tag="label" className="fw-bold mb-2 mt-4">
                      Select Inventory
                    </MDBTypography>

                    {/* Dropdown for selecting ONE inventory */}
                    <select
                      className="form-select mb-3"
                      value={formProductData.selectedInventoryItem || ""}
                      onChange={(e) => {
                        setFormProductData({
                          ...formProductData,
                          selectedInventoryItem: e.target.value,
                        });
                      }}
                    >
                      <option value="">-- Select Inventory Item --</option>
                      {inventory.map((item) => (
                        <option key={item.product_no} value={item.product_no}>
                          {item.description} ({item.product_no})
                        </option>
                      ))}
                    </select>

                    {/* Quantity textfield */}
                    <MDBInput
                      label="Quantity"
                      type="number"
                      min="1"
                      value={formProductData.quantity || ""}
                      onChange={(e) => {
                        setFormProductData({
                          ...formProductData,
                          quantity: parseInt(e.target.value) || "",
                        });
                      }}
                    />

      
      
                    {formError && <p className="text-danger small mb-0">{formError}</p>}
                  </MDBModalBody>
      
                  <MDBModalFooter>
                    <MDBBtn color="danger" onClick={toggleCreateModal}>Cancel</MDBBtn>
                    <MDBBtn color="success" onClick={handleCreateProduct}>Create</MDBBtn>
                  </MDBModalFooter>
                </MDBModalContent>
              </MDBModalDialog>
            </MDBModal>

    </div>
  );
}

export default ProductsTab;
